import React from 'react'
import Pt from 'prop-types'
import { connect } from 'react-redux'

import PageLoading from '../../components/Layout/PageLoading'

import { begin } from '../../redux/modules/signupEdit/actions'

export class IncomingView extends React.Component {
  componentWillMount() {
    this.props.begin(this.props.location)
  }

  render() {
    return (
      <section className="container">
        <PageLoading />
      </section>
    )
  }
}

IncomingView.defaultProps = {
  loading: false,
}

IncomingView.propTypes = {
  begin: Pt.func.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  location: Pt.object.isRequired,
}

export default connect(
  null,
  {
    begin,
  },
)(IncomingView)



// WEBPACK FOOTER //
// ./src/views/SignupForm/IncomingView.jsx